import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";

/**
 * دور المستخدم الحالي كما يراه الخادم.
 *
 * يُستعمل لتشكيل الواجهة فقط — الصلاحية الحقيقية مفروضة في Convex،
 * فإخفاء زر لا يعني منع الوصول، والمنع يتم هناك على كل حال.
 */
export function useRole() {
  const me = useQuery(api.users.me, {});
  return {
    me,
    role: me?.role ?? null,
    isAdmin: me?.role === "admin",
    loading: me === undefined,
  };
}
